import React, { useEffect, useState } from "react";
import ChatMessages from "./ChatMessages";
import ChatInput from "./ChatInput";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { apiMainUser } from "../../../utils/constant";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
// import {
//   SET_RIGHT_SIDE_CONTENT,
//   SET_SELECTED_ROOM_ID_MESSAGES,
// } from "../../../utils/redux/User/MessageUserSideSlice";

import {
  SET_MESSAGES_LOADING,
  SET_RIGHT_SIDE_CONTENT,
  SET_SELECTED_ROOM_ID_MESSAGES,
  fetchChatByRoomIdThunk,
} from "../../../utils/redux/messageSlice";

// chat messages and chat input
// fetch chat for selected roomID

const ChatBox = ({ assetsurl, moveToThirdStep, type, setStep }) => {
  const [searchParams, setSearcParams] = useSearchParams();
  const [messages, setMessages] = useState([]);
  // const [messagesLoading, setMessagesLoading] = useState();
  const [messagesError, setMessagesError] = useState();

  const [rightSideContent, setRightSideContent] = useState();

  const dispatch = useDispatch();
  // const room_id = searchParams.get("room_id");

  const queryParams = new URLSearchParams(window.location.search);

  const room_id = queryParams.get("room_id");

  // const { selectedRoomId } = useSelector(
  //   (state) => state.MessageUserSide
  // );

  const { selectedRoomId, messagesLoading } = useSelector(
    (state) => state.Message
  );

  const fetchChatByRoomId = async (roomId) => {
    try {
      // setMessagesLoading(true);
      dispatch(SET_MESSAGES_LOADING(true));

      const headers = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await axios.get(
        apiMainUser + `read_chat_user/${roomId}`,
        { headers }
      );

      if (response.status === 200) {
        console.log("API Response:", response.data);
        setRightSideContent(response.data.data.chat_room_details[0]);

        dispatch(
          SET_RIGHT_SIDE_CONTENT(response.data.data.chat_room_details[0])
        );

        dispatch(
          SET_SELECTED_ROOM_ID_MESSAGES(response.data.data.message_array)
        );

        setMessages(response.data.data.message_array);
      } else {
        console.error("Failed to fetch chat:", response.status);
      }
    } catch (error) {
      console.error("Error fetching chat:", error);
    } finally {
      // setMessagesLoading(false);
      dispatch(SET_MESSAGES_LOADING(false));
    }
  };

  useEffect(() => {
    console.log("===> chat box useEffect <===");
    // alert("useEffect ran");

    console.log("room ID selected");
    // dispatch(fetchChatByRoomIdThunk({ roomId: selectedRoomId }));
    // setMessages([]);

    if (selectedRoomId) fetchChatByRoomId(selectedRoomId);
  }, [selectedRoomId]);

  return (
    <>
      {messagesLoading && <h3>Messages Loading...</h3>}
      {!messagesLoading && (
        <ChatMessages
          // messages={messages}
          // setMessages={setMessages}
          // messagesLoading={messagesLoading}
          rightSideContent={rightSideContent}
          assetsurl={assetsurl}
          moveToThirdStep={moveToThirdStep}
          type={type}
          setStep={setStep}
        />
      )}

      <ChatInput
        lead_events={rightSideContent?.lead_event_details?.[0]?.uid}
        room_id={rightSideContent?.room_id}
        type={type}
      />
    </>
  );
};

export default ChatBox;
